export function computeStyleGlobalVariable(variableName) {
  return getComputedStyle(document.querySelector(':root')).getPropertyValue(
    `var(${variableName})`.split('var(').join('').split(')').join('')
  )
}
